import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11ec29d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-course-id", "data-page-id", "data-part-id", "data-exposure-time"]
const _hoisted_2 = { class: "explain" }
const _hoisted_3 = { class: "wap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ft-weight" }, "练习说明>>>", -1))
const _hoisted_5 = { class: "desc-box" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "code-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mode-head" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "name" }, "代码输入区")
], -1))
const _hoisted_9 = { class: "example-box" }
const _hoisted_10 = ["id"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "结果输出区", -1))
const _hoisted_12 = { class: "result-box" }
const _hoisted_13 = { class: "output-box" }
const _hoisted_14 = ["id"]

import {nextTick, onMounted, ref, Ref} from 'vue'
import {PageRecord} from "@/models/page/pageRecord";
import CompareCode from "@/models/page/compareCode";
import OnlineCodeEditor from '@/components/OnlineCodeEditor/CodeEditor.vue';
import {isNotEmpty} from "@/utils/tools";
import { contentRender } from "@/lib/contentRender";
import RunStatus from '@/components/OnlineCodeEditor/components/RunStatus.vue';
import { fetchCodeCommit } from '@/apis/recorded';

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'CompareHintPage',
  props: {
    page: {},
    userPage: {},
    courseId: {},
    partId: {},
    pageId: {}
  },
  setup(__props: any) {

const props = __props

// type OnlineCodeEditorType = InstanceType<typeof OnlineCodeEditor>
// const editorRef = ref<OnlineCodeEditorType>()
let editorRef: Ref<HTMLElement | null> = ref(null);

const codeOps: Record<string, unknown> = {
  codeRef: "codeArea" + props.page.id,
  outputAreaRef: "outputArea" + props.page.id,
  kernelOptions: {
    path: ""
  },
  mode: 'python',
};

const initCode = () => {
  const code = isNotEmpty(props.userPage.userAnswer)?props.userPage.userAnswer
    :isNotEmpty(props.page.code)? props.page.code: '// 请输入代码'
  editorRef?.value?.getCodeMirror()?.setValue(code)
}


let hideDesc = ref("");
onMounted(async () => {
  await nextTick()
  initCode();

  hideDesc.value = contentRender(props.page.desc);

});

//运行代码
const runCode = async () => {
  const onlineCodeEditor = editorRef?.value;
  if (onlineCodeEditor) {
    const code = onlineCodeEditor?.getCodeMirror()?.getValue();
    if(code){
      await onlineCodeEditor.execute(code);
    }
    await fetchCodeCommit({
      courseId: props.courseId,
      partId: props.partId,
      recordedPageId: props.pageId,
      code: code,
    })
  }
}
// 代码运行后的状态
let codeRunStatus = ref('notRun');
const changeStatus = (status:string)=>{
  codeRunStatus.value = status;
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "exposure compare-page",
    "data-course-id": _ctx.courseId,
    "data-page-id": _ctx.pageId,
    "data-part-id": _ctx.partId,
    "data-exposure-time": _ctx.userPage.exposureTime
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", {
            class: "desc",
            innerHTML: _unref(hideDesc)
          }, null, 8, _hoisted_6)
        ])
      ])
    ]),
    _createVNode(OnlineCodeEditor, {
      ref_key: "editorRef",
      ref: editorRef,
      ops: codeOps,
      onChangeStatus: changeStatus
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", {
              class: "example",
              id: 'codeArea' + _ctx.page.id,
              ref: 'codeArea' + _ctx.page.id
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", { class: "run-box" }, [
            _hoisted_11,
            _createElementVNode("div", { class: "btn-box" }, [
              _createElementVNode("button", {
                class: "btn",
                onClick: runCode
              }, " 运行代码 ")
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: "result",
              id: 'outputArea' + _ctx.page.id,
              ref: 'outputArea' + _ctx.page.id
            }, null, 8, _hoisted_14)
          ]),
          _createVNode(RunStatus, {
            item: _ctx.page,
            showErrorHelp: _unref(codeRunStatus) == 'error',
            showSuccessShare: _unref(codeRunStatus) == 'ok'
          }, null, 8, ["item", "showErrorHelp", "showSuccessShare"])
        ])
      ]),
      _: 1
    }, 512)
  ], 8, _hoisted_1))
}
}

})